import React from 'react';
import styled from 'styled-components';
import { colors } from '../../styles';

const Input = ({ icon, ...props }) => (
  <InputWrapper>
    {icon && <IconWrapper>{icon}</IconWrapper>}
    <StyledInput $hasIcon={!!icon} {...props} />
  </InputWrapper>
);

const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const IconWrapper = styled.span`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: ${colors.text}80;
  z-index: 1;
`;

const StyledInput = styled.input`
  width: 100%;
  height: 42px;
  padding: ${props => props.$hasIcon ? '0 12px 0 36px' : '0 12px'};
  border: 1px solid ${colors.border};
  border-radius: 8px;
  font-family: 'Indie Flower', cursive;
  font-size: 1rem;
  
  &:hover, &:focus {
    outline: none;
    border-color: ${colors.secondary};
  }

  &:disabled {
    background-color: ${colors.border}20;
    cursor: not-allowed;
  }
`;

export default Input; 